import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

import cookiesContent from "./content/cookies.md?raw";
import privacyContent from "./content/privacy.md?raw";
import termsContent from "./content/terms.md?raw";

import { PublicNavbar } from "@/components/public-navbar";
import { SeoHead } from "@/components/seo-head";

function MarkdownPage({
  content,
  title,
  description,
  canonical,
}: {
  content: string;
  title: string;
  description: string;
  canonical: string;
}) {
  return (
    <div className="min-h-screen">
      <SeoHead title={title} description={description} canonical={canonical} />
      <PublicNavbar />
      <article className="prose prose-invert prose-themed prose-sm sm:prose-base mx-auto max-w-3xl px-4 py-10 sm:px-6">
        {content.trim() ? (
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
        ) : (
          <p className="text-muted-foreground">Coming soon.</p>
        )}
      </article>
    </div>
  );
}

export function PrivacyPage() {
  return (
    <MarkdownPage
      content={privacyContent}
      title="Privacy Policy"
      description="TodoLLM privacy policy - how we collect, use, and protect your data."
      canonical="https://todollm.com/privacy"
    />
  );
}

export function TermsPage() {
  return (
    <MarkdownPage
      content={termsContent}
      title="Terms of Service"
      description="TodoLLM terms of service - the rules and conditions governing use of the platform."
      canonical="https://todollm.com/terms"
    />
  );
}

export function CookiesPage() {
  return (
    <MarkdownPage
      content={cookiesContent}
      title="Cookie Policy"
      description="TodoLLM cookie policy - the essential cookies we use and why."
      canonical="https://todollm.com/cookies"
    />
  );
}
